export const C = {
  container: { padding: '20px' },
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
    flexWrap: 'wrap',
    gap: '12px',
  },
  title: { fontSize: '22px', fontWeight: 700, color: 'var(--agx-text)', margin: 0 },
  topActions: { display: 'flex', alignItems: 'center', gap: '8px' },
  selectSede: {
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid var(--agx-border)',
    fontSize: '13px',
    fontFamily: 'inherit',
    backgroundColor: 'var(--agx-surface)',
    cursor: 'pointer',
    minWidth: '180px',
    color: 'var(--agx-text)',
  },
  btnIcon: {
    padding: '8px',
    borderRadius: '8px',
    border: '1px solid var(--agx-border)',
    backgroundColor: 'var(--agx-surface)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    color: 'var(--agx-muted)',
  },

  statsRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
    gap: '12px',
    marginBottom: '20px',
  },

  tabBar: {
    display: 'flex',
    gap: '0',
    marginBottom: '20px',
    borderBottom: '1px solid var(--agx-border)',
    overflowX: 'auto',
  },
  tab: {
    padding: '10px 16px',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontSize: '13px',
    fontFamily: 'inherit',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    transition: 'all 0.15s',
  },

  filterBar: { display: 'flex', gap: '10px', marginBottom: '12px', flexWrap: 'wrap' },
  searchWrap: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'var(--agx-surface)',
    borderRadius: '10px',
    border: '1px solid var(--agx-border)',
    padding: '0 12px',
    minWidth: '200px',
  },
  searchInput: {
    flex: 1,
    padding: '10px 8px',
    border: 'none',
    outline: 'none',
    fontSize: '13px',
    fontFamily: 'inherit',
    backgroundColor: 'transparent',
    color: 'var(--agx-text)',
  },
  clearBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: 'var(--agx-faint)',
    display: 'flex',
    alignItems: 'center',
  },
  selectDepto: {
    padding: '8px 12px',
    borderRadius: '10px',
    border: '1px solid var(--agx-border)',
    fontSize: '13px',
    fontFamily: 'inherit',
    backgroundColor: 'var(--agx-surface)',
    cursor: 'pointer',
    minWidth: '180px',
    color: 'var(--agx-text)',
  },

  tableWrap: {
    backgroundColor: 'var(--agx-surface)',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
  },
  table: { width: '100%', borderCollapse: 'collapse', minWidth: '700px' },
  th: {
    textAlign: 'left',
    padding: '10px 12px',
    fontSize: '11px',
    fontWeight: 600,
    color: 'var(--agx-muted)',
    textTransform: 'uppercase',
    borderBottom: '1px solid var(--agx-border)',
    backgroundColor: 'var(--agx-bg2)',
    whiteSpace: 'nowrap',
  },
  tr: { borderBottom: '1px solid var(--agx-border)', transition: 'background 0.1s' },
  td: { padding: '8px 12px', fontSize: '13px', color: 'var(--agx-text)', verticalAlign: 'middle' },
  emptyRow: {
    textAlign: 'center',
    padding: '40px 14px',
    color: 'var(--agx-muted)',
    fontSize: '14px',
  },
  badge: {
    padding: '2px 6px',
    borderRadius: '8px',
    fontSize: '10px',
    fontWeight: 600,
    fontFamily: 'monospace',
  },
  btnDetalle: {
    padding: '4px 10px',
    borderRadius: '6px',
    border: '1px solid var(--agx-border)',
    backgroundColor: 'var(--agx-surface)',
    color: 'var(--agx-pri2)',
    cursor: 'pointer',
    fontSize: '11px',
    fontWeight: 500,
    fontFamily: 'inherit',
  },
  btnDetalleSm: {
    padding: '3px 8px',
    borderRadius: '6px',
    border: '1px solid var(--agx-border)',
    backgroundColor: 'var(--agx-surface)',
    color: 'var(--agx-pri2)',
    cursor: 'pointer',
    fontSize: '11px',
    fontFamily: 'inherit',
  },
  btnIconSm: {
    padding: '4px',
    borderRadius: '6px',
    border: '1px solid var(--agx-border)',
    backgroundColor: 'var(--agx-surface)',
    color: 'var(--agx-muted)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  btnCargarMas: {
    padding: '8px 24px',
    borderRadius: '8px',
    border: '1px solid var(--agx-border)',
    backgroundColor: 'var(--agx-surface)',
    color: 'var(--agx-pri2)',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 500,
    fontFamily: 'inherit',
  },

  deptosGrid: { display: 'flex', flexDirection: 'column', gap: '8px' },
  deptoCard: {
    backgroundColor: 'var(--agx-surface)',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    overflow: 'hidden',
  },
  deptoHeader: {
    padding: '14px 16px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    transition: 'background 0.1s',
  },
  deptoProducts: { borderTop: '1px solid var(--agx-border)', padding: '8px 0' },
  deptoProdRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '8px 16px',
    borderBottom: '1px solid var(--agx-border)',
    fontSize: '13px',
  },
  btnMover: {
    padding: '3px 8px',
    borderRadius: '6px',
    border: '1px solid var(--agx-border)',
    backgroundColor: 'var(--agx-surface)',
    color: 'var(--agx-muted)',
    cursor: 'pointer',
    fontSize: '11px',
    fontFamily: 'inherit',
    display: 'flex',
    alignItems: 'center',
    gap: '3px',
  },
  deptoMenu: {
    display: 'none',
    position: 'absolute',
    right: 0,
    top: '100%',
    zIndex: 10,
    backgroundColor: 'var(--agx-surface)',
    borderRadius: '8px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
    padding: '6px 0',
    minWidth: '180px',
    overflow: 'hidden',
  },
  deptoMenuTitle: {
    padding: '6px 12px',
    fontSize: '11px',
    fontWeight: 600,
    color: 'var(--agx-faint)',
    textTransform: 'uppercase',
  },
  deptoMenuItem: {
    padding: '8px 12px',
    fontSize: '13px',
    cursor: 'pointer',
    color: 'var(--agx-text)',
  },

  prioForm: { marginBottom: '16px' },
  inputF: {
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid var(--agx-border)',
    fontSize: '13px',
    fontFamily: 'inherit',
    outline: 'none',
    flex: 1,
    minWidth: '140px',
    color: 'var(--agx-text)',
    backgroundColor: 'var(--agx-input-bg)',
  },
  btnAdd: {
    padding: '8px 16px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: 'var(--agx-pri2)',
    color: '#fff',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 500,
    fontFamily: 'inherit',
    whiteSpace: 'nowrap',
  },
  btnDel: {
    padding: '4px 10px',
    borderRadius: '6px',
    border: 'none',
    backgroundColor: 'var(--agx-red-bg)',
    color: 'var(--agx-red)',
    cursor: 'pointer',
    fontSize: '11px',
    fontWeight: 500,
    fontFamily: 'inherit',
  },
  btnClearSel: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: 'var(--agx-faint)',
    display: 'flex',
    alignItems: 'center',
  },
  searchDropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    zIndex: 10,
    backgroundColor: 'var(--agx-surface)',
    borderRadius: '8px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
    maxHeight: '240px',
    overflow: 'auto',
  },
  searchItem: {
    padding: '8px 10px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    borderBottom: '1px solid var(--agx-border)',
  },
  selectedProduct: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
    backgroundColor: 'var(--agx-green-bg)',
    borderRadius: '8px',
    marginTop: '4px',
  },
};

export const BS = {
  red: {
    backgroundColor: '#fce8e6',
    color: '#c5221f',
    padding: '2px 8px',
    borderRadius: '10px',
    fontSize: '12px',
    fontWeight: 600,
  },
  amber: {
    backgroundColor: '#fef7e0',
    color: '#ea8600',
    padding: '2px 8px',
    borderRadius: '10px',
    fontSize: '12px',
    fontWeight: 600,
  },
  blue: {
    backgroundColor: '#e8f0fe',
    color: '#1967d2',
    padding: '2px 8px',
    borderRadius: '10px',
    fontSize: '12px',
    fontWeight: 600,
  },
  green: {
    backgroundColor: '#e6f4ea',
    color: '#137333',
    padding: '2px 8px',
    borderRadius: '10px',
    fontSize: '12px',
    fontWeight: 600,
  },
};

export const M = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 2000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  modal: {
    backgroundColor: 'var(--agx-surface)',
    borderRadius: '16px',
    maxWidth: '700px',
    width: '100%',
    maxHeight: '90vh',
    overflow: 'auto',
    position: 'relative',
    boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
  },
  modalWide: {
    backgroundColor: 'var(--agx-surface)',
    borderRadius: '16px',
    maxWidth: '860px',
    width: '100%',
    maxHeight: '92vh',
    overflow: 'auto',
    position: 'relative',
    boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
  },
  closeBtn: {
    position: 'absolute',
    top: '12px',
    right: '12px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: 'var(--agx-muted)',
    zIndex: 1,
    display: 'flex',
    padding: '4px',
  },
  shareBtn: {
    position: 'absolute',
    top: '12px',
    right: '48px',
    background: '#25D366',
    border: 'none',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    cursor: 'pointer',
    color: '#fff',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalBody: { display: 'flex', gap: '24px', padding: '28px', flexWrap: 'wrap' },
  imageSection: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '180px',
  },
  infoSection: { flex: 1, minWidth: '280px' },
  prodName: { fontSize: '18px', fontWeight: 600, color: 'var(--agx-text)', margin: '0 0 4px' },
  detailGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '16px' },
  detailItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    padding: '8px',
    backgroundColor: 'var(--agx-bg2)',
    borderRadius: '8px',
  },
  detailLabel: {
    fontSize: '11px',
    fontWeight: 600,
    color: 'var(--agx-faint)',
    textTransform: 'uppercase',
  },
  detailValue: { fontSize: '14px', fontWeight: 500, color: 'var(--agx-text)' },
  clasifSection: {
    backgroundColor: 'var(--agx-bg2)',
    padding: '12px',
    borderRadius: '8px',
    marginBottom: '8px',
  },
  detHero: {
    display: 'flex',
    gap: '24px',
    padding: '28px 28px 16px',
    flexWrap: 'wrap',
    '@media (max-width: 600px)': { flexDirection: 'column', alignItems: 'center' },
  },
  detHeroImg: {
    width: '200px',
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  detHeroViewer: {
    width: '100%',
    height: '200px',
    borderRadius: '12px',
    overflow: 'hidden',
    background: 'var(--agx-skeleton)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  detThumbs: {
    display: 'flex',
    gap: '6px',
    overflowX: 'auto',
    paddingBottom: '4px',
    marginTop: '8px',
    width: '100%',
    justifyContent: 'center',
  },
  detThumb: {
    width: '44px',
    height: '44px',
    borderRadius: '6px',
    overflow: 'hidden',
    flexShrink: 0,
    cursor: 'pointer',
    border: '2px solid transparent',
    background: 'var(--agx-skeleton)',
  },
  detHeroInfo: { flex: 1, minWidth: '260px' },
  detHeroName: {
    fontSize: '20px',
    fontWeight: 700,
    color: 'var(--agx-text)',
    margin: '0 0 4px',
    lineHeight: 1.3,
  },
  detHeroCode: {
    fontFamily: 'monospace',
    color: 'var(--agx-muted)',
    fontSize: '13px',
    marginBottom: '12px',
  },
  detInfoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
    gap: '6px',
  },
  detInfoCell: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1px',
    padding: '6px 10px',
    backgroundColor: 'var(--agx-bg2)',
    borderRadius: '8px',
  },
  detInfoLbl: {
    fontSize: '10px',
    fontWeight: 600,
    color: 'var(--agx-faint)',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
  },
  detInfoVal: { fontSize: '14px', fontWeight: 500, color: 'var(--agx-text)' },
  detSectionBox: {
    backgroundColor: 'var(--agx-bg2)',
    padding: '10px 28px',
    margin: '0 28px 4px',
    borderRadius: '8px',
    fontSize: '12px',
  },
  detTabs: {
    display: 'flex',
    gap: '0',
    borderBottom: '1px solid var(--agx-border)',
    margin: '16px 28px 0',
    overflowX: 'auto',
  },
  detTab: {
    padding: '10px 16px',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontSize: '12px',
    fontFamily: 'inherit',
    display: 'flex',
    alignItems: 'center',
    borderBottom: '2px solid transparent',
    whiteSpace: 'nowrap',
    transition: 'all 0.15s',
  },
  detTabContent: { padding: '16px 28px 28px' },
  detKpiGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
    gap: '10px',
  },
  detKpiCard: {
    backgroundColor: 'var(--agx-bg2)',
    padding: '14px',
    borderRadius: '10px',
    textAlign: 'center',
  },
  detKpiVal: { fontSize: '20px', fontWeight: 700, color: 'var(--agx-text)' },
  detKpiLbl: { fontSize: '11px', color: 'var(--agx-muted)', marginTop: '2px', fontWeight: 500 },
  detTableWrap: {
    maxHeight: '260px',
    overflowY: 'auto',
    borderRadius: '8px',
    border: '1px solid var(--agx-border)',
  },
  detTh: {
    padding: '6px 8px',
    background: 'var(--agx-bg2)',
    textAlign: 'left',
    fontWeight: 600,
    color: 'var(--agx-muted)',
    fontSize: '11px',
    borderBottom: '1px solid var(--agx-border)',
    whiteSpace: 'nowrap',
    position: 'sticky',
    top: 0,
  },
  detTd: { padding: '6px 8px', fontSize: '12px', color: 'var(--agx-text)', whiteSpace: 'nowrap' },
};

export const SY = {
  label: {
    display: 'block',
    fontSize: '12px',
    fontWeight: 600,
    color: 'var(--agx-muted)',
    marginBottom: '4px',
  },
  select: {
    width: '100%',
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid var(--agx-border)',
    fontSize: '13px',
    fontFamily: 'inherit',
    backgroundColor: 'var(--agx-surface)',
    outline: 'none',
    color: 'var(--agx-text)',
  },
  input: {
    width: '100%',
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid var(--agx-border)',
    fontSize: '13px',
    fontFamily: 'inherit',
    outline: 'none',
    boxSizing: 'border-box',
    color: 'var(--agx-text)',
    backgroundColor: 'var(--agx-input-bg)',
  },
};

export const IMG = {
  select: {
    width: '100%',
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid var(--agx-border)',
    fontSize: '13px',
    fontFamily: 'inherit',
    backgroundColor: 'var(--agx-surface)',
    color: 'var(--agx-text)',
  },
  fileInput: { width: '100%', padding: '8px 0', fontSize: '13px', fontFamily: 'inherit' },
};
